import { Pipe, type PipeTransform } from '@angular/core';
import { BulkPrice, CartridgeServicePackage } from '@markant-platform/cartridge/model';

@Pipe({
  name: 'getServicePackageName',
  standalone: true,
  pure: true,
})
export class ServicePackageNamePipe implements PipeTransform {
  transform(bulkPrice: BulkPrice, servicePackages: CartridgeServicePackage[] = []): string | undefined {
    return servicePackages.find(servicePackage => servicePackage.id === bulkPrice.cartridgeServicePackageId)?.name;
  }
}
